import React, { useState } from 'react';
import { Box, Tab, Tabs, Theme, Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RoomStructureHeader } from '../../../../definitions/schemas';
import { RoomSectionHeaderProps } from './types';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderBottom: 'var(--avatar-background-default) solid 1px',
  },
  tab: {
    // the maxWidth value is used to display 25 characters in Preview and Contact View page
    maxWidth: theme.spacing(25.125),
    minWidth: '0',
    textTransform: 'none',
  },
  tabName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre',
    width: '100%',
  },
}));

const RoomHeadersTabs: React.FC<RoomSectionHeaderProps> = (
  props: RoomSectionHeaderProps
) => {
  const classes = useStyles();

  const { onClick, structureHeaders } = props;

  const [value, setValue] = useState<string>();

  const handleChange = (_: React.ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  const handleOnClick = (header: RoomStructureHeader) => {
    if (onClick) {
      onClick(header);
    }
  };

  const renderHeaderTabs = () =>
    structureHeaders.map((header) => (
      <Tab
        key={header.id}
        className={classes.tab}
        label={
          <Tooltip
            arrow
            placement="bottom"
            title={header.name || ''}
            enterTouchDelay={0}
            leaveTouchDelay={5000}
          >
            <Typography className={classes.tabName} variant="body2">
              {header.name}
            </Typography>
          </Tooltip>
        }
        onClick={() => handleOnClick(header)}
        value={header.id}
      />
    ));

  return (
    <Box className={classes.root}>
      <Tabs
        indicatorColor="secondary"
        onChange={handleChange}
        scrollButtons="auto"
        textColor="inherit"
        value={value || false}
        variant="scrollable"
      >
        {renderHeaderTabs()}
      </Tabs>
    </Box>
  );
};

export default RoomHeadersTabs;
